import { render } from "./SubmitRules.vue?vue&type=template&id=053c03cc"
import script from "./SubmitRules.vue?vue&type=script&lang=js"
export * from "./SubmitRules.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2025.48.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__